<template>
    <form @submit.prevent="submit">
        <div 
            id="search-filters" 
            :class="!showContactSearch ? 'collapsed-box' : ''" 
            class="box box-primary">
            <div 
                class="box-header with-border filters-header" 
                @click.prevent="toggleSearch">
                <h3 class="box-title"><i 
                    class="fa fa-search" 
                    aria-hidden="true"/> Filtri / iskanje</h3>

                <div class="box-tools pull-right">
                    <button 
                        type="button" 
                        class="btn btn-box-tool">
                        <i 
                            :class="!showContactSearch ? 'fa-plus' : 'fa-minus'" 
                            class="fa"/>
                    </button>
                </div>
            </div>
            <div 
                :style="!showContactSearch ? {display: 'none'} : {}" 
                class="box-body">
                <div class="row">
                    <div class="col-md-3">
                        <contact-search-text 
                            v-model="search.email"
                            :has.sync="search.has_email"
                            html-for="email"
                            title="E-poštni naslov"/>
                        <contact-search-text 
                            v-model="search.phone"
                            :has.sync="search.has_phone"
                            html-for="phone"
                            title="Telefon"/>
                        <contact-search-text 
                            v-model="search.name"
                            :has.sync="search.has_name"
                            html-for="name"
                            title="Ime"/>
                    </div>
                    <div class="col-md-3">
                        <contact-search-number 
                            v-model="search.birthday"
                            :has.sync="search.has_birthday"
                            :min="1900"
                            :max="(new Date()).getFullYear()"
                            :step="1"
                            html-for="birthday"
                            title="Leto rojstva"/>
                        <contact-search-text 
                            v-model="search.mobile_phone"
                            :has.sync="search.has_mobile_phone"
                            html-for="mobile_phone"
                            title="Mobilni telefon"/>
                        <contact-search-text 
                            v-model="search.address"
                            :has.sync="search.has_address"
                            html-for="address"
                            title="Naslov"/>
                    </div>
                    <div class="col-md-3">
                        <contact-search-multiselect 
                            v-model="search.post"
                            :options="posts"
                            :has.sync="search.has_post"
                            :label="multiselectPostLabel"
                            html-for="post"
                            title="Pošta"/>
                        <contact-search-multiselect 
                            v-model="search.municipality"
                            :options="municipalities"
                            :has.sync="search.has_municipality"
                            html-for="municipality"
                            title="Občina"/>
                        <contact-search-multiselect 
                            v-model="search.region"
                            :options="regions"
                            :has.sync="search.has_region"
                            html-for="region"
                            title="Regija"/>
                    </div>
                    <div class="col-md-3">
                        <contact-search-text
                            v-model="search.tax_id"
                            :has.sync="search.has_tax_id"
                            html-for="tax_id"
                            title="Davčna številka"/>
                        <contact-search-multiselect 
                            v-model="search.sex"
                            :options="sexes"
                            html-for="sex"
                            title="Spol"/>
                        <contact-search-multiselect 
                            v-model="search.source"
                            :options="sources"
                            html-for="source"
                            title="Vir"/>
                    </div>
                </div>
            </div>
            <div 
                :style="!showContactSearch ? {display: 'none'} : {}" 
                class="box-footer">
                <button 
                    class="btn btn-md btn-primary" 
                    type="submit">Išči</button>
                <button 
                    class="btn btn-md btn-danger"
                    @click.prevent="resetSearch">
                    Ponastavi
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import ContactsCommon           from '../../mixins/Contacts';
import {decode, encode}         from '../Base64';
import pickBy                   from 'lodash/pickBy';
import ContactSearchText        from './Components/Text';
import ContactSearchNumber      from './Components/Number';
import ContactSearchMultiselect from './Components/Multiselect';

export default {
    name: 'ContactSearch',

    components: {
        'contact-search-text':        ContactSearchText,
        'contact-search-number':      ContactSearchNumber,
        'contact-search-multiselect': ContactSearchMultiselect
    },

    mixins: [
        ContactsCommon
    ],

    data() {
        return {
            sources:                  [],
            sourcesSessionKey:        'sources',
            sourcesSessionTimeoutKey: 'sources_timeout',
            search:                   {
                email:                   null,
                has_email:               0,
                mailing_lists_count:     null,
                has_mailing_lists_count: 0,
                phone:                   null,
                has_phone:               0,
                mobile_phone:            null,
                has_mobile_phone:        0,
                tax_id:                  null,
                has_tax_id:              0,
                name:                    null,
                has_name:                0,
                sex:                     null,
                birthday:                null,
                has_birthday:            0,
                address:                 null,
                has_address:             0,
                post:                    null,
                has_post:                0,
                municipality:            null,
                has_municipality:        0,
                region:                  null,
                has_region:              0,
                source:                  null
            },
            showContactSearch:        false
        };
    },

    created() {
        this.getSources();
        this.showContactSearch = this.$ls.get('showContactSearch') || false;

        this.preFillSearchFields();
    },

    methods: {
        preFillSearchFields() {
            //let gotDataFromUrl = false;

            if (this.$root.params) {
                if (this.search) {
                    for (let keyword of Object.keys(this.search)) {
                        if (keyword in this.$root.params && this.$root.params[keyword] !== '') {
                            this.$set(this.search, keyword, this.$root.params[keyword]);
                            //gotDataFromUrl = true;
                        }
                    }
                }
            }

            // This was a nice idea but did more bad than good :P
            // if (!gotDataFromUrl && this.$session.exists('search')) {
            //     this.$set(this, 'search', JSON.parse(this.$session.get('search')));
            //     this.submit();
            // }
        },

        getSources() {
            let now = new Date();

            if (!this.$session.exists(this.sourcesSessionKey) ||
                    !this.$session.exists(this.sourcesSessionTimeoutKey) ||
                    this.$session.get(this.sourcesSessionKey) < now.getTime()
            ) {
                axios.get('/ajax/sources', {
                    params: {
                        no_paginate: 1,
                        sort:        'name|asc'
                    }
                })
                    .then(response => {
                        this.$set(this, 'sources', response.data.data);

                        now.setMinutes(now.getMinutes() + 1);

                        this.$session.set(this.sourcesSessionTimeoutKey, now.getTime());
                        this.$session.set(this.sourcesSessionKey, encode(this.sources));
                    })
                    .catch(error => {
                        if ('errors' in error.response.data && error.response.data.errors) {
                            for (let field in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(field)) {
                                    this.$toast.error({
                                        title:   'NAPAKA!',
                                        message: error.response.data.errors[field][0],
                                        timeOut: 10000
                                    });
                                }
                            }
                        }
                    });
            } else {
                this.$set(this, 'sources', decode(this.$session.get(this.sourcesSessionKey)));
            }
        },

        resetSearch() {
            this.$set(this.search, 'email', null);
            this.$set(this.search, 'has_email', 0);
            this.$set(this.search, 'mailing_lists_count', null);
            this.$set(this.search, 'has_mailing_lists_count', 0);
            this.$set(this.search, 'phone', null);
            this.$set(this.search, 'mobile_phone', null);
            this.$set(this.search, 'has_phone', 0);
            this.$set(this.search, 'tax_id', null);
            this.$set(this.search, 'has_tax_id', 0);
            this.$set(this.search, 'name', null);
            this.$set(this.search, 'has_name', 0);
            this.$set(this.search, 'sex', null);
            this.$set(this.search, 'birthday', null);
            this.$set(this.search, 'has_birthday', 0);
            this.$set(this.search, 'address', null);
            this.$set(this.search, 'has_address', 0);
            this.$set(this.search, 'post', null);
            this.$set(this.search, 'has_post', 0);
            this.$set(this.search, 'municipality', null);
            this.$set(this.search, 'has_municipality', 0);
            this.$set(this.search, 'region', null);
            this.$set(this.search, 'has_region', 0);
            this.$set(this.search, 'source', null);
            this.$session.remove('search');

            this.submit();
        },

        prepareData() {
            let data = (
                ({
                    email, mailing_lists_count, phone, tax_id, name, address, post, has_email, has_phone, has_mobile_phone,
                    has_tax_id, has_name, has_birthday, has_address, has_post, has_municipality, has_region, has_mailing_lists_count
                }) => ({
                    email,
                    mailing_lists_count,
                    phone,
                    tax_id,
                    name,
                    address,
                    post,
                    has_email,
                    has_phone,
                    has_mobile_phone,
                    has_tax_id,
                    has_name,
                    has_birthday,
                    has_address,
                    has_post,
                    has_municipality,
                    has_region,
                    has_mailing_lists_count
                })
            )(this.search);

            data['sex'] = this.search.sex ? this.search.sex.id : null;
            data['birthday'] = this.search.birthday ? this.search.birthday + '-01-01' : null;
            data['municipality'] = this.search.municipality ? this.search.municipality.name : null;
            data['region'] = this.search.region ? this.search.region.name : null;
            data['source_id'] = this.search.source ? this.search.source.id : null;

            return pickBy(data);
        },

        submit() {
            this.$events.fire('search', this.prepareData());
            this.$session.set('search', JSON.stringify(this.search));
        },

        toggleSearch() {
            this.$set(this, 'showContactSearch', !this.showContactSearch);
            this.$ls.set('showContactSearch', this.showContactSearch);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/ContactSearch.vue